import { render } from "./CustomerVerifyWildcard.vue?vue&type=template&id=20e0091d&scoped=true"
import script from "./CustomerVerifyWildcard.vue?vue&type=script&lang=js"
export * from "./CustomerVerifyWildcard.vue?vue&type=script&lang=js"

import "./CustomerVerifyWildcard.vue?vue&type=style&index=0&id=20e0091d&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e0091d"]])

export default __exports__